import useOnValueChange from "../../../hooks/useOnValueChange";
import { InputProps } from "../Calculator";
import NumberInput from "../../BuildingBlocks/NumberInput/NumberInput";

const TITLE = "דמי ניהול מהפקדות";
const SUBTITLE = "אחוז דמי ניהול מהפקדות חודשיות";
const NAME = "deposit-fees";

const DepositFeesInput = ({ contextKey }: InputProps) => {
  const onValueChange = useOnValueChange(contextKey);

  return (
    <NumberInput
      title={TITLE}
      placeholder={SUBTITLE}
      name={NAME}
      onlyPositive
      isRate={true}
      onChange={(value: number) => onValueChange(value)}
    />
  );
};

export default DepositFeesInput;
